import { FC } from 'react';
import GroupFieldBase, { TGroupFieldBaseProps } from './GroupFieldBase';

const CheckboxGroupField: FC<Omit<TGroupFieldBaseProps<true>, 'multiple'>> = (
  props
) => {
  return <GroupFieldBase multiple {...props} />;
};

export default CheckboxGroupField;
